(() => {
  // Recover failed editorial requests using only this image's own responsive sources.
  const images = document.querySelectorAll('.cat-experience img, .cat-product-story img, .halloween-product-content img');
  images.forEach(image => {
    const candidates = (image.getAttribute('srcset') || '').split(',').map(entry => {
      const [source, descriptor] = entry.trim().split(/\s+/);
      return {source, width: Number.parseInt(descriptor, 10)};
    }).filter(candidate => candidate.source && candidate.width > 0)
      .sort((a, b) => a.width - b.width);
    if (candidates.length < 2) return;
    let attempts = 0;
    let timer = null;
    let failedSource = '';
    let waitingForConnection = false;
    const recover = () => {
      if (timer || attempts >= 2) return;
      if (!navigator.onLine) {
        waitingForConnection = true;
        return;
      }
      const currentSource = new URL(image.currentSrc || image.src, location.href).href;
      if (currentSource === failedSource) return;
      const current = candidates.findIndex(candidate => new URL(candidate.source, location.href).href === currentSource);
      const next = current > 0 ? current - 1 : current === 0 ? 1 : candidates.length - 2;
      if (next < 0 || (current === 0 && attempts > 0)) return;
      failedSource = currentSource;
      attempts += 1;
      image.dataset.imageRecovery = 'retrying';
      timer = window.setTimeout(() => {
        timer = null;
        // Changing the selected size avoids reusing a failed request cached by the browser.
        image.loading = 'eager';
        const retryCandidates = current === 0 ? [candidates[next]] : candidates.slice(0, next + 1);
        image.srcset = retryCandidates.map(candidate => candidate.source + ' ' + candidate.width + 'w').join(', ');
        image.src = candidates[next].source;
      }, attempts === 1 ? 400 : 1200);
    };
    image.addEventListener('error', recover);
    image.addEventListener('load', () => {
      image.dataset.imageRecovery = 'loaded';
      waitingForConnection = false;
      if (timer) window.clearTimeout(timer);
      timer = null;
    });
    window.addEventListener('online', () => {
      if (!waitingForConnection) return;
      waitingForConnection = false;
      recover();
    });
    // An error may have happened before this small async script arrived.
    if (image.complete && !image.naturalWidth) recover();
  });
})();
